
import giraffe from "@/assets/giraffe.jpg"
import _1er_etoile from "@/assets/default_service_images/_1er_etoile.jpg"
import _2eme_etoile from "@/assets/default_service_images/_2eme_etoile.jpg"
import _3eme_etoile from "@/assets/default_service_images/_3eme_etoile.jpg"
import casque from "@/assets/default_service_images/casque.png"
import esf from "@/assets/default_service_images/esf.jpg"
import transport from "@/assets/default_service_images/transport.png"
import transfer from "@/assets/default_service_images/transfer.png"
import flocon from "@/assets/default_service_images/flocon.jpg"
import panier_enfant from "@/assets/default_service_images/panier_enfant.jpg"
import panier_gastronomique from "@/assets/default_service_images/panier_gastronomique.jpg"
import panier_gourmand_halal from "@/assets/default_service_images/panier_gourmand_halal.jpg"
import panier_gourmand from "@/assets/default_service_images/panier_gourmand.jpg"
import piou_piou from "@/assets/default_service_images/piou_piou.jpg"
import skipass from "@/assets/default_service_images/skipass.jpg"
import ski_Argent from "@/assets/default_service_images/Ski_Argent.jpg"
import ski_Bronze from "@/assets/default_service_images/Ski_Bronze.jpg"
import ski_Champion from "@/assets/default_service_images/Ski_Champion.jpg"
import ski_Eco from "@/assets/default_service_images/Ski_Eco.jpg"
import ski_Espoir from "@/assets/default_service_images/Ski_Espoir.jpg"
import ski_Mini_Kid from "@/assets/default_service_images/Ski_Mini_Kid.jpg"
import ski_Or from "@/assets/default_service_images/Ski_Or.jpg"
import snowboard_Champion from "@/assets/default_service_images/Snowboard_Champion.jpg"
import snowboard_Espoir from "@/assets/default_service_images/Snowboard_Espoir.jpg"
import snowboard_Or from "@/assets/default_service_images/Snowboard_Or.jpg"
import snowboardArgent from "@/assets/default_service_images/SnowboardArgent.jpg"
import ski_Argent_90deg from "@/assets/default_service_images/Ski_Argent_90deg.png"
import ski_Bronze_90deg from "@/assets/default_service_images/Ski_Bronze_90deg.png"
import ski_Champion_90deg from "@/assets/default_service_images/Ski_Champion_90deg.png"
import ski_Eco_90deg from "@/assets/default_service_images/Ski_Eco_90deg.png"
import ski_Espoir_90deg from "@/assets/default_service_images/Ski_Espoir_90deg.png"
import ski_Mini_Kid_90deg from "@/assets/default_service_images/Ski_Mini_Kid_90deg.png"
import ski_Or_90deg from "@/assets/default_service_images/Ski_Or_90deg.png"
import snowboard_Champion_90deg from "@/assets/default_service_images/Snowboard_Champion_90deg.png"
import snowboard_Espoir_90deg from "@/assets/default_service_images/Snowboard_Espoir_90deg.png"
import snowboard_Or_90deg from "@/assets/default_service_images/Snowboard_Or_90deg.png"
import snowboardArgent_90deg from "@/assets/default_service_images/SnowboardArgent_90deg.png"
import CritEnum from "@/enum/CritEnum"

 

type Image = any
// Chaussures = "1001",
// Battons = "1002",
// Snowboard = "1014",
// Ski = "1015",
export const criteriaToName: Map<CritEnum[], Image> = new Map(
    [
        /** SkiSchool */
        [[CritEnum.Piou_Piou], ""],
        [[CritEnum.Flocon], ""],
        [[CritEnum._1ere_etoile], ""],
        [[CritEnum._2eme_etoile], ""],
        [[CritEnum._3eme_etoile], ""],

 

        /** SNOWBOARD */
        // snowboard eco (boots)
        [[CritEnum.Snowboard, CritEnum.Economique, CritEnum.Chaussures], ""],
        // snowboard eco
        [[CritEnum.Snowboard, CritEnum.Economique], ""],
        // snowboard argent (boots)
        [[CritEnum.Snowboard, CritEnum.Débutant, CritEnum.Chaussures], "pack_argent_snowboard_name"],
        // snowboard argent
        [[CritEnum.Snowboard, CritEnum.Débutant], "snowboard_seul_argent_name"],
        // snowboard or (boots)
        [[CritEnum.Snowboard, CritEnum.Confirmé, CritEnum.Chaussures], "pack_or_snowboard_name"],
        // snowboard or
        [[CritEnum.Snowboard, CritEnum.Confirmé], "snowboard_seul_or_name"],
        // snowboard platine (boots)
        [[CritEnum.Snowboard, CritEnum.Premium, CritEnum.Chaussures], ""],
        // snowboard platine
        [[CritEnum.Snowboard, CritEnum.Premium], ""],
        // snowboard espoir (boots)
        [[CritEnum.Snowboard, CritEnum.Espoir, CritEnum.Chaussures], "pack_espoir_snowboard_name"],
        // snowboard espoir
        [[CritEnum.Snowboard, CritEnum.Espoir], "snowboard_seul_espoir_name"],
        // snowboard champion (boots)
        [[CritEnum.Snowboard, CritEnum.Champion, CritEnum.Chaussures], "pack_champion_snowboard_name"],
        // snowboard champion
        [[CritEnum.Snowboard, CritEnum.Champion], "snowboard_seul_champion_name"],

 

        /** SKIS */
        // skis eco (boots + sticks)
        [[CritEnum.Ski, CritEnum.Economique, CritEnum.Chaussures, CritEnum.Battons], "pack_eco_name"],
        // skis eco (sticks)
        [[CritEnum.Ski, CritEnum.Economique, CritEnum.Battons], "skis_seuls_eco_name"],
        // skis eco (boots)
        [[CritEnum.Ski, CritEnum.Economique, CritEnum.Chaussures], "pack_eco_name"],
        // skis eco
        [[CritEnum.Ski, CritEnum.Economique], "skis_seuls_eco_name"],
        // skis argent (boots + sticks)
        [[CritEnum.Ski, CritEnum.Débutant, CritEnum.Chaussures, CritEnum.Battons], "pack_argent_name"],
        // skis argent (sticks)
        [[CritEnum.Ski, CritEnum.Débutant, CritEnum.Battons], "skis_seuls_argent_name"],
        // skis argent (boots)
        [[CritEnum.Ski, CritEnum.Débutant, CritEnum.Chaussures], "pack_argent_name"],
        // skis argent
        [[CritEnum.Ski, CritEnum.Débutant], "skis_seuls_argent_name"],
        // skis or (boots + sticks)
        [[CritEnum.Ski, CritEnum.Confirmé, CritEnum.Chaussures, CritEnum.Battons], "pack_or_name"],
    // skis or (sticks)
        [[CritEnum.Ski, CritEnum.Confirmé, CritEnum.Battons], "skis_seuls_or_name"],
        // skis or (boots)
        [[CritEnum.Ski, CritEnum.Confirmé, CritEnum.Chaussures], "pack_or_name"],
        // skis or
        [[CritEnum.Ski, CritEnum.Confirmé], "skis_seuls_or_name"],
        // skis platine (boots + sticks)
        [[CritEnum.Ski, CritEnum.Premium, CritEnum.Chaussures, CritEnum.Battons], ""],
        // skis platine (sticks)
        [[CritEnum.Ski, CritEnum.Premium, CritEnum.Battons], ""],
        // skis platine (boots)
        [[CritEnum.Ski, CritEnum.Premium, CritEnum.Chaussures], ""],
        // skis platine
        [[CritEnum.Ski, CritEnum.Premium], ""],
        // skis espoir (boots)
        [[CritEnum.Ski, CritEnum.Espoir, CritEnum.Chaussures], "pack_espoir_name"],
        // skis espoir
        [[CritEnum.Ski, CritEnum.Espoir], "skis_seuls_espoir_name"],
        // skis champion (boots)
        [[CritEnum.Ski, CritEnum.Champion, CritEnum.Chaussures], "pack_champion_name"],
        // skis champion
        [[CritEnum.Ski, CritEnum.Champion], "skis_seuls_champion_name"],
        // skis mini kid (boots)
        [[CritEnum.Ski, CritEnum.Mini_Kid, CritEnum.Chaussures], "pack_mini_kid_name"],
        // skis mini kid
        [[CritEnum.Ski, CritEnum.Mini_Kid], "skis_seuls_mini_kid_name"],


 

        /** FOOD */
        // food gastronomique
        [[CritEnum.Panier_Gastronomique], "panier_gastronomique_name"],
        // food gourmand
        [[CritEnum.Panier_Gourmand], "panier_gourmand_name"],
        // food hallal
        [[CritEnum.Panier_Hallal], "panier_hallal_name"],
        // food enfant hallal
        [[CritEnum.Panier_Enfant], "panier_enfant_hallal_name"],
        // food enfant
        [[CritEnum.Panier_Enfant], "panier_enfant_name"],
    ]
)
export const criteriaToDescription: Map<CritEnum[], Image> = new Map(
    [
        /** SkiSchool */
        [[CritEnum.Piou_Piou], ""],
        [[CritEnum.Flocon], ""],
        [[CritEnum._1ere_etoile], ""],
        [[CritEnum._2eme_etoile], ""],
        [[CritEnum._3eme_etoile], ""],

 

        /** SNOWBOARD */
        // snowboard eco (boots)
        [[CritEnum.Snowboard, CritEnum.Economique, CritEnum.Chaussures], ""],
        // snowboard eco
        [[CritEnum.Snowboard, CritEnum.Economique], ""],
        // snowboard argent (boots)
        [[CritEnum.Snowboard, CritEnum.Débutant, CritEnum.Chaussures], "pack_argent_snowboard_description"],
        // snowboard argent
        [[CritEnum.Snowboard, CritEnum.Débutant], "snowboard_seul_argent_description"],
        // snowboard or (boots)
        [[CritEnum.Snowboard, CritEnum.Confirmé, CritEnum.Chaussures], "pack_or_snowboard_description"],
        // snowboard or
        [[CritEnum.Snowboard, CritEnum.Confirmé], "snowboard_seul_or_description"],
        // snowboard platine (boots)
        [[CritEnum.Snowboard, CritEnum.Premium, CritEnum.Chaussures], ""],
        // snowboard platine
        [[CritEnum.Snowboard, CritEnum.Premium], ""],
        // snowboard espoir (boots)
        [[CritEnum.Snowboard, CritEnum.Espoir, CritEnum.Chaussures], "pack_espoir_snowboard_description"],
        // snowboard espoir
        [[CritEnum.Snowboard, CritEnum.Espoir], "snowboard_seul_espoir_description"],
        // snowboard champion (boots)
        [[CritEnum.Snowboard, CritEnum.Champion, CritEnum.Chaussures], "pack_champion_snowboard_description"],
        // snowboard champion
        [[CritEnum.Snowboard, CritEnum.Champion], "snowboard_seul_champion_description"],

 

        /** SKIS */
        // skis eco (boots + sticks)
        [[CritEnum.Ski, CritEnum.Economique, CritEnum.Chaussures, CritEnum.Battons], "pack_eco_description"],
        // skis eco (sticks)
        [[CritEnum.Ski, CritEnum.Economique, CritEnum.Battons], "skis_seuls_eco_description"],
        // skis eco (boots)
        [[CritEnum.Ski, CritEnum.Economique, CritEnum.Chaussures], "pack_eco_description"],
        // skis eco
        [[CritEnum.Ski, CritEnum.Economique], "skis_seuls_eco_description"],
        // skis argent (boots + sticks)
        [[CritEnum.Ski, CritEnum.Débutant, CritEnum.Chaussures, CritEnum.Battons], "pack_argent_description"],
        // skis argent (sticks)
        [[CritEnum.Ski, CritEnum.Débutant, CritEnum.Battons], "skis_seuls_argent_description"],
        // skis argent (boots)
        [[CritEnum.Ski, CritEnum.Débutant, CritEnum.Chaussures], "pack_argent_description"],
        // skis argent
        [[CritEnum.Ski, CritEnum.Débutant], "skis_seuls_argent_description"],
        // skis or (boots + sticks)
        [[CritEnum.Ski, CritEnum.Confirmé, CritEnum.Chaussures, CritEnum.Battons], "pack_or_description"],
        // skis or (sticks)
        [[CritEnum.Ski, CritEnum.Confirmé, CritEnum.Battons], "skis_seuls_or_description"],
        // skis or (boots)
        [[CritEnum.Ski, CritEnum.Confirmé, CritEnum.Chaussures], "pack_or_description"],
        // skis or
        [[CritEnum.Ski, CritEnum.Confirmé], "skis_seuls_or_description"],
        // skis platine (boots + sticks)
        [[CritEnum.Ski, CritEnum.Premium, CritEnum.Chaussures, CritEnum.Battons], ""],
        // skis platine (sticks)
        [[CritEnum.Ski, CritEnum.Premium, CritEnum.Battons], ""],
        // skis platine (boots)
        [[CritEnum.Ski, CritEnum.Premium, CritEnum.Chaussures], ""],
        // skis platine
        [[CritEnum.Ski, CritEnum.Premium], ""],
        // skis espoir (boots)
        [[CritEnum.Ski, CritEnum.Espoir, CritEnum.Chaussures], "pack_espoir_description"],
        // skis espoir
        [[CritEnum.Ski, CritEnum.Espoir], "skis_seuls_espoir_description"],
        // skis champion (boots)
        [[CritEnum.Ski, CritEnum.Champion, CritEnum.Chaussures], "pack_champion_description"],
        // skis champion
        [[CritEnum.Ski, CritEnum.Champion], "skis_seuls_champion_description"],
        // skis mini kid (boots)
        [[CritEnum.Ski, CritEnum.Mini_Kid, CritEnum.Chaussures], "pack_mini_kid_description"],
        // skis mini kid
        [[CritEnum.Ski, CritEnum.Mini_Kid], "skis_seuls_mini_kid_description"],

 

        /** FOOD */
        // food gastronomique
        [[CritEnum.Panier_Gastronomique], "panier_gastronomique_description"],
        // food gourmand
        [[CritEnum.Panier_Gourmand], "panier_gourmand_description"],
        // food hallal
        [[CritEnum.Panier_Hallal], "panier_hallal_description"],
        // food enfant hallal
        [[CritEnum.Panier_Hallal], "panier_enfant_hallal_description"],
        // food enfant
        [[CritEnum.Panier_Enfant], "panier_enfant_description"],
    ]
)

 

export const criteriaToImage: Map<CritEnum[], Image> = new Map(
    [
        /** SkiSchool */
        [[CritEnum.Piou_Piou], piou_piou],
        [[CritEnum.Flocon], flocon],
        [[CritEnum._1ere_etoile], _1er_etoile],
        [[CritEnum._2eme_etoile], _2eme_etoile],
        [[CritEnum._3eme_etoile], _3eme_etoile],

 

        /** SNOWBOARD */
        // snowboard argent
        [[CritEnum.Snowboard, CritEnum.Débutant], snowboardArgent],
        // snowboard or
        [[CritEnum.Snowboard, CritEnum.Confirmé], snowboard_Or],
    // snowboard espoir
        [[CritEnum.Snowboard, CritEnum.Espoir], snowboard_Espoir],
    // snowboard champion
        [[CritEnum.Snowboard, CritEnum.Champion], snowboard_Champion],

 

        /** SKIS */
        // skis eco
        [[CritEnum.Ski, CritEnum.Economique], ski_Eco],
        // skis argent
        [[CritEnum.Ski, CritEnum.Débutant], ski_Argent],
        // skis or
        [[CritEnum.Ski, CritEnum.Confirmé], ski_Or],
        // skis espoir
        [[CritEnum.Ski, CritEnum.Espoir], ski_Espoir],
        // skis champion
        [[CritEnum.Ski, CritEnum.Champion], ski_Champion],
        // skis mini kid
        [[CritEnum.Ski, CritEnum.Mini_Kid], ski_Mini_Kid],

 

        /** FOOD */
        // food gastronomique
        [[CritEnum.Panier_Gastronomique], panier_gastronomique],
        // food gourmand
        [[CritEnum.Panier_Gourmand], panier_gourmand],
        // food hallal
        [[CritEnum.Panier_Hallal], panier_gourmand_halal],
        // food enfant
        [[CritEnum.Panier_Enfant], panier_enfant],
    ]
)
export const criteriaToImage_90deg: Map<CritEnum[], Image> = new Map(
    [
        /** SNOWBOARD */
        // snowboard argent
        [[CritEnum.Snowboard, CritEnum.Débutant], snowboardArgent_90deg],
        // snowboard or
        [[CritEnum.Snowboard, CritEnum.Confirmé], snowboard_Or_90deg],
    // snowboard espoir
        [[CritEnum.Snowboard, CritEnum.Espoir], snowboard_Espoir_90deg],
    // snowboard champion
        [[CritEnum.Snowboard, CritEnum.Champion], snowboard_Champion_90deg],

 

        /** SKIS */
        // skis eco
        [[CritEnum.Ski, CritEnum.Economique], ski_Eco_90deg],
        // skis argent
        [[CritEnum.Ski, CritEnum.Débutant], ski_Argent_90deg],
        // skis or
        [[CritEnum.Ski, CritEnum.Premium], ski_Or_90deg],
        // skis espoir
        [[CritEnum.Ski, CritEnum.Espoir], ski_Espoir_90deg],
        // skis champion
        [[CritEnum.Ski, CritEnum.Champion], ski_Champion_90deg],
        // skis mini kid
        [[CritEnum.Ski, CritEnum.Mini_Kid], ski_Mini_Kid_90deg],
    ]
)

export const criteriaToServiceContent: Map<string, string[]> = new Map([
    [CritEnum.first_class, ["baggage_cabin", "backpack", "wifi", "meal", "dinner"]],
    [CritEnum.second_class, ["baggage_cabin", "backpack", "wifi"]],
])

export const familyIdToImage: Map<string, Image> = new Map(
    [
        ["3", skipass],
        ["75", skipass],
        ["30", casque],
        ["64", esf],
        ["12", esf],
        ["8", transport],
        ["78", transfer],
    ]
)